(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  class VideoReels extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('.reels__stage');
      this.reels = Array.from(this.querySelectorAll('.reel'));
      if (!this.reels.length) return;
      const fi = this.reels.findIndex((r) => r.dataset.featured === 'true');
      this.active = fi >= 0 ? fi : Math.floor(this.reels.length / 2);
      this.inView = false;

      this.reels.forEach((reel, i) => {
        reel.addEventListener('click', (e) => {
          if (e.target.closest('.reel__btn') || e.target.closest('.reel__shop')) return;
          if (i !== this.active) this.setActive(i);
        });
        const snd = reel.querySelector('.reel__sound');
        if (snd) snd.addEventListener('click', (e) => { e.stopPropagation(); this.toggleSound(reel); });
        const fs = reel.querySelector('.reel__fs');
        if (fs) fs.addEventListener('click', (e) => { e.stopPropagation(); this.fullscreen(reel); });
      });

      const prev = this.querySelector('.reels__arrow--prev');
      const next = this.querySelector('.reels__arrow--next');
      if (prev) prev.addEventListener('click', () => this.setActive(this.active - 1));
      if (next) next.addEventListener('click', () => this.setActive(this.active + 1));

      this._onResize = () => this.layout();
      window.addEventListener('resize', this._onResize);

      this.io = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.playActive(); else this.pauseAll();
      }, { threshold: 0.2 });
      this.io.observe(this);

      // first paint without animation
      this.stage.classList.add('no-anim');
      this.setActive(this.active);
      requestAnimationFrame(() => { this.layout(); requestAnimationFrame(() => this.stage.classList.remove('no-anim')); });
      window.addEventListener('load', () => this.layout());
    }

    spread() {
      const w = window.innerWidth;
      return w >= 990 ? 165 : (w >= 750 ? 135 : 64);
    }

    setActive(i) {
      const n = this.reels.length;
      this.active = ((i % n) + n) % n; // wrap around (circular)
      this.reels.forEach((r, idx) => {
        const on = idx === this.active;
        r.classList.toggle('is-active', on);
        if (!on) {
          const v = r.querySelector('.reel__video');
          if (v) { v.pause(); v.muted = true; this.setSoundIcon(r, true); }
        }
      });
      this.layout();
      if (this.inView) this.playActive();
    }

    layout() {
      const spread = this.spread();
      const n = this.reels.length;
      const half = n / 2;
      this.reels.forEach((r, idx) => {
        // shortest circular distance from the active reel (so reels wrap sides)
        let off = idx - this.active;
        if (off > half) off -= n;
        if (off < -half) off += n;
        const a = Math.abs(off);
        const scale = Math.max(0.6, 1 - a * 0.12);
        // All reels stay fully opaque so you never see one video THROUGH another;
        // overlap is hidden simply because the front reel (higher z-index) covers
        // the part of the reel behind it. Depth comes from scale, not fading.
        const op = 1;
        const tf = 'translateX(calc(-50% + ' + (off * spread) + 'px)) scale(' + scale + ')';
        // a reel that jumped from one far side to the other should teleport,
        // not fly across the screen — kill its transition for this frame only.
        const wrapped = r._off !== undefined && Math.abs(off - r._off) > half;
        r._off = off;
        if (wrapped) r.style.transition = 'none';
        r.style.zIndex = String(100 - a);
        r.style.opacity = String(op);
        r.style.transform = tf;
        if (wrapped) { r.getBoundingClientRect(); r.style.transition = ''; }
      });
      const act = this.reels[this.active];
      if (act) this.stage.style.height = act.offsetHeight + 'px';
    }

    playActive() {
      const v = this.reels[this.active] && this.reels[this.active].querySelector('.reel__video');
      if (!v) return;
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    }
    pauseAll() { this.reels.forEach((r) => { const v = r.querySelector('.reel__video'); if (v) v.pause(); }); }

    toggleSound(reel) {
      const v = reel.querySelector('.reel__video');
      if (!v) return;
      v.muted = !v.muted;
      if (!v.muted) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      this.setSoundIcon(reel, v.muted);
    }
    setSoundIcon(reel, muted) {
      const m = reel.querySelector('.reel__i-muted');
      const o = reel.querySelector('.reel__i-on');
      if (m) m.hidden = !muted;
      if (o) o.hidden = muted;
    }
    fullscreen(reel) {
      const v = reel.querySelector('.reel__video');
      if (!v) return;
      const fn = v.requestFullscreen || v.webkitRequestFullscreen || v.webkitEnterFullscreen;
      if (fn) { v.muted = false; this.setSoundIcon(reel, false); try { fn.call(v); } catch (e) {} }
    }
  }
  if (!customElements.get('video-reels')) customElements.define('video-reels', VideoReels);

  } catch(e) { console.error(e); }
})();
})();
